import React from 'react';

const Loader = ({ size = 'md', color = 'yellow' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  const colorClasses = {
    yellow: 'border-custom-yellow',
    gray: 'border-custom-gray',
    white: 'border-white'
  };

  return (
    <div className="flex justify-center items-center h-screen w-full">
      <div
        className={`${sizeClasses[size]} border-2 border-custom-yellow border-t-transparent rounded-full animate-spin `}
      ></div>
    </div>
  );
};

export default Loader;
